import "antd/es/empty/style";
import _Empty from "antd/es/empty";
import "antd/es/button/style";
import _Button from "antd/es/button";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/no-unused-prop-types */
import React, { useCallback, useImperativeHandle, useRef, useState, useEffect } from 'react';
import Trigger from 'rc-trigger';
import BUILT_IN_PLACEMENTS from '../libs/placement';
import Menu from './Menu';
import Checkbox from './Checkbox';
import "../index.css";
import MultiCascaderContainer from '../container';
import Selector from './Selector';
import { matchAllLeafValue as _matchAllLeafValue, reconcile } from '../libs/utils';

var Popup = function Popup(props) {
  var ref = useRef(null);
  var data = props.data,
      selectAll = props.selectAll,
      selectAllDisabled = props.selectAllDisabled,
      onCancel = props.onCancel,
      onConfirm = props.onConfirm,
      onLayout = props.onLayout;

  var _MultiCascaderContain = MultiCascaderContainer.useContainer(),
      flattenData = _MultiCascaderContain.flattenData;

  useEffect(function () {
    if (onLayout) {
      onLayout(ref.current);
    }
  }, [onLayout]);
  return /*#__PURE__*/React.createElement("div", {
    className: "biz-component-multi-cascader-popup",
    ref: ref
  }, data && data.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Menu, null), /*#__PURE__*/React.createElement("div", {
    className: "biz-component-multi-cascader-popup-footer"
  }, selectAll ? /*#__PURE__*/React.createElement("div", {
    className: "biz-component-multi-cascader-popup-all"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    node: _objectSpread(_objectSpread({}, flattenData[0]), {}, {
      disabled: selectAllDisabled
    })
  }), "\xA0\xA0All") : null, /*#__PURE__*/React.createElement("div", {
    className: "biz-component-multi-cascader-popup-buttons"
  }, /*#__PURE__*/React.createElement(_Button, {
    size: "small",
    onClick: onCancel
  }, "Cancel"), /*#__PURE__*/React.createElement(_Button, {
    size: "small",
    type: "primary",
    onClick: onConfirm
  }, "Confirm")))) : /*#__PURE__*/React.createElement(_Empty, {
    image: _Empty.PRESENTED_IMAGE_SIMPLE
  }));
};

var Component = /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(function (props, ref) {
  var selectorRef = useRef(null);
  var onChange = props.onChange,
      disabled = props.disabled,
      getPopupContainer = props.getPopupContainer;

  var _MultiCascaderContain2 = MultiCascaderContainer.useContainer(),
      popupVisible = _MultiCascaderContain2.popupVisible,
      setPopupVisible = _MultiCascaderContain2.setPopupVisible,
      flattenData = _MultiCascaderContain2.flattenData,
      value = _MultiCascaderContain2.value,
      setValue = _MultiCascaderContain2.setValue,
      resetMenuState = _MultiCascaderContain2.resetMenuState,
      selectedItems = _MultiCascaderContain2.selectedItems;

  var handleCancel = useCallback(function () {
    setPopupVisible(false);
  }, []);
  var triggerChange = useCallback(function (nextValue) {
    if (onChange) {
      onChange(nextValue, selectedItems.slice(0));
    }

    setPopupVisible(false);
  }, [selectedItems]);
  var handleItemRemove = useCallback(function (item) {
    var nextValue;

    if (typeof item === 'string') {
      nextValue = value.filter(function (v) {
        return v !== item;
      });
    } else {
      nextValue = reconcile(item, false, value);
    }

    setValue(nextValue);
    triggerChange(nextValue);
  }, [value, triggerChange]);
  var handleClear = useCallback(function () {
    resetMenuState();
    triggerChange([]);
  }, [resetMenuState, triggerChange]);
  var handleConfirm = useCallback(function () {
    triggerChange(value);
  }, [triggerChange, value]);
  useImperativeHandle(ref, function () {
    return {
      // 匹配所有叶子节点的 value
      matchAllLeafValue: function matchAllLeafValue(v) {
        return _matchAllLeafValue(v, flattenData);
      }
    };
  }, [flattenData]);

  var _useState = useState({
    popupPlacement: 'bottomLeft',
    popupTransitionName: 'slide-up'
  }),
      _useState2 = _slicedToArray(_useState, 1),
      popupPlacement = _useState2[0];

  return /*#__PURE__*/React.createElement(Trigger, _objectSpread(_objectSpread({
    action: !disabled ? ['click'] : [],
    prefixCls: "biz-component-multi-cascader",
    popup: /*#__PURE__*/React.createElement(Popup, _objectSpread(_objectSpread({}, props), {}, {
      onCancel: handleCancel,
      onConfirm: handleConfirm
    })),
    popupVisible: disabled ? false : popupVisible,
    onPopupVisibleChange: setPopupVisible,
    popupStyle: {
      position: 'absolute'
    },
    builtinPlacements: BUILT_IN_PLACEMENTS
  }, popupPlacement), {}, {
    getPopupContainer: getPopupContainer
  }), /*#__PURE__*/React.createElement(Selector, _objectSpread({
    forwardRef: selectorRef,
    onRemove: handleItemRemove,
    onClear: handleClear
  }, props)));
}));
var MultiCascader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(MultiCascaderContainer.Provider, {
    initialState: props
  }, /*#__PURE__*/React.createElement(Component, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })));
});
MultiCascader.defaultProps = {
  data: [],
  value: []
};
export default MultiCascader;